<template>
  <div :class="$style.inputArea">
    <div :class="$style.textField">
      <label
        :class="$style.label"
        for="field">{{ computedLabel }}
      </label>
      <div
        v-click-outside="hideMenu"
        ref="input"
        :field="field"
        :class="$style.inputField"
        :required="computedRequired"
        :placeholder="placeholder"
        :value="value"
        :autocomplete="autocomplete"
        @change="updateValue()"
        @click="showDropdown">
        <ul
          v-if="show"
          :class="$style.multiselect">
          <li
            v-for="(option, index) in options"
            :key="index"
            :class="$style.listOption">
            <input
              :id="index"
              :value="option.value"
              v-model="selected"
              :class="$style.checkbox"
              type="checkbox"
            >
            <label :for="index">{{ option.name }}</label>
          </li>
        </ul>
        <div :class="$style.content">
          {{ fieldValue }}
        </div>
      </div>
      <div
        :class="$style.caret"
        @click="showDropdown"/>
    </div>
  </div>
</template>

<script lang="ts">
// eslint-disable-next-line lines-around-comment
/* Vue Components */
import SelectOption from './FormField.Select.Option.vue';

/* Meteor packages */

/* NPM packages */

/* Methods */
import ClickOutside from 'vue-click-outside';

/* Everything else */
import validatedFieldMixin from '../../mixins/validatedField';

export default {
  directives: { ClickOutside },
  components: { SelectOption },
  mixins: [validatedFieldMixin],
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: [],
    },
    field: {
      type: String,
      required: true,
    },
    validator: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      selected: [],
      selectedObjects: [],
    };
  },
  computed: {
    fieldValue() {
      return this.selectedObjects.join('; ');
    },
  },
  watch: {
    selected(val) {
      this.$emit('checked', val);
    },
  },
  methods: {
    showDropdown(e) {
      this.show = true; //!this.show;
    },
    updateValue() {
      this.selectedObjects = this.options
        .filter((option) => {
          return this.selected.includes(option.value);
        })
        .map((option) => {
          return option.name;
        });
      this.$emit('input', this.selected);
    },
    getKey(option) {
      return option.value || option;
    },
    hideMenu() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss" module>
@import 'src/brand/brandColors.variables';

.multiselect {
  position: absolute;
  width: calc(100% + 2px);
  top: 4.8rem;
  left: -1px;
  list-style: none;
  display: flex;
  flex-flow: column nowrap;
  padding: 0;
  margin: 0;
  background-color: #ffffff;
  border: 1px solid $gray-light;
  border-radius: 0;
  z-index: 9;
}

.listOption {
  display: flex;
  width: 100%;
  align-items: center;
  padding: 1.2rem 2.4rem;

  label {
    flex-grow: 1;
    text-align: left;
  }

  &:hover {
    background: $gray-light;
  }
}

.checkbox {
  flex-grow: 0;
  padding: 0;
  margin: 0 1rem 0 0;
}

.inputArea {
  margin: 0 1.6rem 1.6rem 0;
  flex: 1;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  max-width: 37.1rem;
}

.textField {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  height: 5rem;
  position: relative;
}

.label {
  composes: standard from "src/brand/typography.scss";
  display: flex;
  justify-content: flex-start;
  padding: 0 2rem;
  align-items: center;
  font-size: 1rem;
  font-weight: 700;
  background: $gray-light;
  color: $steel-gray;
  border: 1px solid $gray-light;
  text-transform: uppercase;
  width: 10rem;
  height: 100%;
}

.content {
  composes: standard from "src/brand/typography.scss";
  position: absolute;
  flex-grow: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 1.6rem 4.8rem 1.6rem 2.4rem;
  overflow-x: auto;
  overflow-y: hidden;
}

.caret {
  width: .96rem;
  height: 5rem;
  position: absolute;
  right: 0;
  content: "";
  background: url(../../assets/arrow.down.svg) no-repeat center;
  padding: 0 2.4rem;
  background-size: 0.96rem;
  background-color: #ffffff;
  border-color: $gray-light;
  border-style: solid;
  border-width: 1px 1px 1px 0;
}

.inputField {
  position: relative;
  composes: standard from "src/brand/typography.scss";
  font-size: 1.4rem;
  color: $blue-dark;
  background-color: $white;
  height: 5rem;
  flex: 1;
  border: 1px solid $gray-light;
  border-radius: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 2.4rem;
  padding-right: 4.8rem;
  text-align: left;
  width: 100%;
  white-space: nowrap;

  &:focus {
    outline: none;
  }
}

.styledSelect {
  background: url(../../assets/arrow.down.svg) no-repeat right 2.4rem center;
  background-size: 0.96rem;
  overflow: hidden;
  composes: standard from "src/brand/typography.scss";
  font-size: 1.4rem;
  color: $blue-dark;
  background-color: $white;
  height: 5rem;
  flex: 1;
  border: 1px solid $gray-light;
  border-radius: 0;
  min-width: 200px;
}

.styledSelect select {
  background: transparent;
  border: none;
  font-size: 1.4rem;
  height: 5rem;
  width: 110%;
}

.errorMessage {
  composes: standard from "src/brand/typography.scss";
  color: $errors;
  display: block;
  margin-top: 0.6rem;
}
</style>
